"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompulsoryDinnerDescriptions = void 0;
const currencyFormatter_1 = require("../currencyFormatter");
const getCompulsoryDinnerDescriptions = (line) => {
    const descriptions = [];
    // Get all unique dinners from both room rates and compulsory dinners
    const uniqueDinners = new Map();
    // Add dinners from room rates
    line.rooms.rooms.forEach((room) => {
        room.rate.forEach((rate) => {
            if (rate?.dinners) {
                rate.dinners.forEach((dinner) => {
                    if (dinner.id) {
                        uniqueDinners.set(dinner.id, dinner);
                    }
                });
            }
        });
    });
    // Add dinner descriptions
    uniqueDinners.forEach((dinner) => {
        // Customize this description based on your HotelContractCompulsoryDinners interface
        descriptions.push(`Compulsory ${dinner.name} (${(0, currencyFormatter_1.currencyFormatter)(line?.supplier?.currency, dinner.cost_price, false)} per person) included in rate`);
    });
    return descriptions.length > 0 ? descriptions : null;
};
exports.getCompulsoryDinnerDescriptions = getCompulsoryDinnerDescriptions;
